import { useEffect, useState } from "react";
import axios from "axios";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";

import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import { env } from "../config";
import { createIcon } from "../utils/mapIcons";

const DEFAULT_CENTER = [33.8938, 35.5018]; // Lebanon center coords

const PassiveCategoryMap = ({ mapSlug, eventSlug, guideSlug }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    if (!mapSlug) return;
    axios
      .get(`${env.baseUrl}/api/maps/grouped/${mapSlug}`)
      .then((res) => setGroups(res.data.groups || []))
      .catch(console.error);
  }, [mapSlug]);

  if (!mapSlug) return null;

  const allPoints = groups.flatMap((group) =>
    group.points.map((p) => ({ ...p, group }))
  );
  const center = allPoints.length
    ? [+allPoints[0].lat, +allPoints[0].lng]
    : DEFAULT_CENTER;

  return (
    <div>
      <MapContainer
        center={center}
        zoom={10}
        style={{ height: "500px", width: "100%" }}
        preferCanvas={true}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="© OpenStreetMap contributors"
        />
        <MarkerClusterGroup
          chunkedLoading
          showCoverageOnHover={false}
          maxClusterRadius={60}
          spiderfyOnMaxZoom={true}
          iconCreateFunction={(cluster) => {
            return L.divIcon({
              html: `<div class="cluster-icon"><span>${cluster.getChildCount()}</span></div>`,
              className: "custom-cluster",
              iconSize: L.point(44, 44),
            });
          }}
        >
          {allPoints.map((p) => (
            <Marker
              key={`${p.group.id}-${p.id}`}
              position={[+p.lat, +p.lng]}
              icon={createIcon(`${env.baseUrl}/${p.group.icon_url}`)}
            >
              <Popup>
                <strong>{p.title}</strong>
                <br />
                {p.description}
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>

      {(eventSlug || guideSlug) && (
        <div className="btn-block" style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
          {eventSlug && (
            <a className="programs-btn" href={`/event-category/${eventSlug}`}>
              Events
            </a>
          )}
          {guideSlug && (
            <a className="programs-btn" href={`/maps-category/${guideSlug}`}>
              Guide
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default PassiveCategoryMap;
